import { render, staticRenderFns } from "./VideoUpscale.vue?vue&type=template&id=c323c7f4&scoped=true"
import script from "./VideoUpscale.vue?vue&type=script&lang=js"
export * from "./VideoUpscale.vue?vue&type=script&lang=js"
import style0 from "./VideoUpscale.vue?vue&type=style&index=0&id=c323c7f4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c323c7f4",
  null
  
)

export default component.exports